import SlimSelect from "slim-select"

import "slim-select/dist/slimselect.css"

import "@components/fields/single-select-field/single-select-field"

/**
 * If you need do something with the slim instance, you can use the following interface
 * @example import {SlimSelectElement} from "js/slim-select/slim-select"
 *
 * const slimSelect = document.querySelector<SlimSelectElement>(".your-select select")
 *
 * slimSelect.slim
 */
export interface SlimSelectElement extends HTMLSelectElement {
  slim?: SlimSelect
}
